<template>
  <div class="fixed-box">
    <ul>
      <li class="qrcode-li" @mouseover="showQrcode=true" @mouseleave="showQrcode=false">
        <a href="javascript:;">
          <i class="icon iconfont iconshouji"></i>
          <p>二维码</p>
        </a> 
        <div class="qrcode" v-show="showQrcode==true">
          <img :src="require('@/assets/images/jshopQrcode.png')" alt="">
        </div>
      </li>
      <li>
        <router-link to="center">
          <i class="icon iconfont icongerenzhongxin"></i>
          <p>个人中心</p>
        </router-link>
      </li>
      <li>
        <a href="javascript:;" @click="showChat">
          <i class="icon iconfont iconkefu1"></i>
          <p>联系客服</p>
        </a>
      </li>
      <li>
        <router-link to="cart">
          <i class="icon iconfont iconcart">
            <span class="nums" v-show="cartNums>0">{{cartNums}}</span>
          </i>
          <p>购物车</p>
        </router-link>
      </li>
    </ul>
    <transition name="el-fade-in">
      <div class="top" @click="scrollToTop" :class="{'active':toTopShow}">
        <i class="icon iconfont iconfanhuidingbu"></i>
        <p>回顶部</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ScrollToTop",
  components: {},
  props: {},
  data() {
    return {
      toTopShow: false,
      showQrcode:false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      cartNums: "cartNums"
    })
  },
  methods: {
    handleScroll() {
      this.scrollTop = this.scrollTop =
        window.pageYOffset || document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    scrollToTop() {
      let timer = null,
        that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (that.scrollTop > 0) {
          that.scrollTop -= 500;
          document.body.scrollTop = document.documentElement.scrollTop =
            that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          that.toTopShow = false;
        }
      });
    },
    showChat(){
      _AIHECONG('showChat')
    }
  },
  created() {},
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll);
    });
    
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.qrcode-li{
  position: relative;
  .qrcode{
    width: 100px;
    height: 100px;
    background:#FFF;
    position: absolute;
    top:0;
    left:-110px;
    z-index: 9999;
    img{
      width: 80px;
      height: 80px;
      margin:10px auto;
    }
  }
}
.fixed-box {
  position: fixed;
  right: 0px;
  bottom: 90px;
  z-index: 999;
  ul {
    background-color: #fff;
    width: 80px;
    margin-bottom: 20px;
    li {
      width: 80px;
      height: 88px;
      text-align: center;
      border-bottom: 1px solid $border;
      cursor: pointer;
      a {
        display: block;
        width: 100%;
        height: 100%;
        padding-top: 20px;
        color: #757575;
        box-sizing: border-box;
        transition: 0.3s;
        .icon {
          display: block;
          width: 30px;
          height: 30px;
          margin: 0 auto 10px;
          font-size: 30px;
          &.iconcart {
            position: relative;
            .nums {
              position: absolute;
              width: 14px;
              height: 14px;
              right: -12px;
              top: -5px;
              font-size: 10px;
              text-align: center;
              line-height: 14px;
              background: $theme-color;
              color: #fff;
              border-radius: 50%;
              border: 2px solid #fff;
            }
          }
        }
        &:hover {
          color: $theme-color;
          .icon {
            color: $theme-color;
          }
        }
      }
    }
  }
}
.top {
  background-color: #fff;
  width: 80px;
  height: 88px;
  cursor: pointer;
  color: #757575;
  transition: 0.3s;
  z-index: 100;
  text-align: center;
  box-sizing: border-box;
  padding-top: 20px;
  visibility: hidden;
  .icon {
    display: block;
    font-size: 30px;
    margin-bottom: 10px;
  }
  &.active {
    visibility: visible;
  }
  &:hover {
    color: $theme-color;
    opacity: 0.8;
    .icon {
      color: $theme-color;
    }
  }
}
</style>